import React, { useState } from 'react'
import { AppCommand } from './app-command'

export function AppCommandDialog() {
  const [open, setOpen] = React.useState(false)
  const [search, setSearch] = useState('')

  React.useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault()
        setOpen((open) => !open)
      }
    }

    document.addEventListener('keydown', down)
    return () => document.removeEventListener('keydown', down)
  }, [])

  return (
    <AppCommand 
      dialogMode={true}
      open={open}
      onOpenChange={setOpen}
      search={search}
      setSearch={setSearch}
    />
  )
} 